module.exports = __webpack_public_path__ + "static/media/HouseSmartVideoEnergySmart.ebba7a98.jpg";